<template>
  <ion-page ref="page">
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/shepherd.js@13.0.0/dist/css/shepherd.css"
    />
    <LargeNavbar
      show-back-button
      show-share-button
      :show-actions="false"
      :title="t('property.titleDetail')"
      @back-button="onBackButton"
    />

    <ion-content :fullscreen="true">
      <div class="blue-decorative"></div>
      <ion-fab-button class="floating-btn" color="white" @click="router.push({ name: 'Support' })">
        <ion-icon color="primary" :icon="chatboxOutline"></ion-icon>
      </ion-fab-button>

      <SmallCardModal>
        <template #body>
          <div v-if="!user" class="unlock-btn">
            <p class="bold-medium">{{ t('announcement.unlockDetails') }}</p>

            <ion-button
              @click="router.push({ name: 'signUp' })"
              fill="solid"
              expand="block"
              color="primary"
              class="text-lg text-weight-bold"
            >
              {{ t('announcement.createAccount') }}
            </ion-button>
            <a @click="router.push({ name: 'login' })" class="bold-medium">{{
              t('announcement.orLogin')
            }}</a>
          </div>

          <ion-row v-else class="ion-justify-content-between ion-align-items-center w-100">
            <div
              v-if="
                propertySelected &&
                propertySelected.RentalUnits &&
                propertySelected.RentalUnits[0].Prices
              "
              class="d-flex gap-sm"
            >
              <span class="text-color-placeholder">{{ t('global.from') }}</span>
              <h1 class="font-md bold-medium primary">
                {{
                  amountMask(
                    propertySelected.RentalUnits[0].Prices[0].amount as number,
                    propertySelected.RentalUnits[0].Prices[0].currency as string,
                  )
                }}/
              </h1>
              <p class="font-sm grey">
                {{
                  t(
                    `announcement.${propertySelected.RentalUnits[0].Prices[0].paymentCycle !== 'Unknown' ? propertySelected.RentalUnits[0].Prices[0].paymentCycle : 'monthly'}`,
                  )
                }}
              </p>
            </div>

            <div>
              <ion-button
                @click="initTour"
                fill="solid"
                expand="block"
                size="default"
                color="primary"
                class="text-lg text-weight-bold ion-align-self-end"
              >
                {{ t('announcement.bookNow') }}
              </ion-button>
            </div>
          </ion-row>
        </template>
      </SmallCardModal>

      <div
        v-if="isLoading"
        class="PageContainer mt-xs bg-white ion-padding border-default d-flex justify-space-center"
        style="padding-right: 10px"
      >
        <div class="content w-100">
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
          <SkeletonLoaderCard :width="'100%'" />
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
        </div>
      </div>
      <div
        v-if="!isLoading"
        class="PageContainer mt-xs bg-white ion-padding border-default d-flex justify-space-center"
      >
        <div class="content mt-sm w-100" v-if="propertySelected">
          <h2 class="font-lg blue-darker test">
            {{ getCurrentNameProperty(propertySelected, languageSelected) }}
          </h2>
          <ion-segment
            style="grid-auto-columns: minmax(auto, 860px)"
            mode="md"
            color="primary"
            v-model="tabSelected"
          >
            <ion-segment-button class="w-100" value="photos" v-if="images && images?.length > 0">
              <ion-label class="w-100 text-weight-bold text-small text-not-capitalize"
                >{{ t('announcement.photos') }}
              </ion-label>
            </ion-segment-button>
            <ion-segment-button
              v-if="propertySelected.Video && propertySelected.Video?.url"
              value="videos"
            >
              <ion-label class="text-weight-bold text-small text-not-capitalize"
                >{{ t('announcement.videos') }}
              </ion-label>
            </ion-segment-button>
            <ion-segment-button
              v-if="propertySelected.VirtualTour && propertySelected.VirtualTour.url"
              value="virtual"
            >
              <ion-label class="text-weight-bold text-small text-not-capitalize"
                >{{ t('announcement.virtual') }}
              </ion-label>
            </ion-segment-button>
          </ion-segment>
          <div
            v-if="tabSelected === 'photos' && images && images?.length > 0"
            class="photos-container border-default"
          >
            <MediaViewer :images="images" type-viewer="property" />
          </div>
          <div v-if="tabSelected === 'videos'" class="photos-container border-default">
            <MediaPreview :url="propertySelected?.Video?.url" />
          </div>
          <div v-if="tabSelected === 'virtual'" class="photos-container border-default">
            <MediaPreview :url="propertySelected?.VirtualTour?.url" />
          </div>

          <div class="announcement-content ion-padding-top mb-lg">
            <p v-html="getCurrentDescription(propertySelected)"></p>

            <div class="b-grey"></div>

            <div class="house">
              <RentalUnitWrapper
                @click="endTour"
                :rental-units="propertySelected?.RentalUnits"
                :language="languageSelected"
              />
            </div>

            <div
              v-if="propertySelected.Features && propertySelected.Features.length > 0"
              class="b-grey"
            ></div>

            <div
              v-if="propertySelected.Features && propertySelected.Features.length > 0"
              class="announcement-content-small"
            >
              <SpacesInformationProperty
                :language="languageSelected"
                :features="propertySelected.Features"
              />
            </div>

            <div class="b-grey"></div>

            <div class="announcement-content-small">
              <div v-if="propertySelected && propertySelected?.Location">
                <h2 class="font-md bold-medium">
                  {{ t('announcement.location') }}
                </h2>
                <div>
                  <MapView :height="'80%'" :location="transformedLocation" :zoom="100" />
                </div>
                <ion-row
                  class="ion-justify-content-start ion-align-items-center price-subtitle nowrap"
                >
                  <ion-icon :icon="locationOutline" size="large" color="grey"></ion-icon>
                  <p class="padding-list-item">
                    {{ propertySelected.Location.fullAddress ?? propertySelected.Location.country }}
                  </p>
                </ion-row>
              </div>
            </div>

            <div class="b-grey"></div>

            <div class="announcement-content-small">
              <!--               <div v-if="propertySelected">
                <h3 class="font-sm bold-medium grey">{{ t('announcement.thisIs') }}</h3>
                <ion-row
                  class="ion-justify-content-start ion-align-items-center price-subtitle nowrap"
                >
                  <ion-chip
                    v-if="
                      propertySelected.occupationTenant &&
                      propertySelected.occupationTenant !== 'indifferent'
                    "
                    >{{ propertySelected.occupationTenant }}
                  </ion-chip>
                  <ion-chip
                    v-if="
                      propertySelected.tenantGender &&
                      propertySelected.tenantGender !== 'indifferent'
                    "
                    >{{ t(`gender.${propertySelected.tenantGender}`) }}
                  </ion-chip>
                  <ion-chip
                    v-if="
                      propertySelected.PropertyType && [
                        `name_${languageSelected}` as keyof ContractModelRelation,
                      ]
                    "
                    >{{
                      propertySelected.PropertyType[
                        `name_${languageSelected}` as keyof ContractModelRelation
                      ]
                    }}
                  </ion-chip>
                </ion-row>
              </div> -->
              <LodginForInformationProperty :property="propertySelected" />
              <div>
                <h3 class="font-sm bold-medium grey">{{ t('announcement.registry') }}</h3>
                <ion-row
                  class="ion-justify-content-start ion-align-items-center price-subtitle nowrap"
                >
                  <p>{{ propertySelected?.referenceCode }}</p>
                </ion-row>
              </div>
            </div>

            <div class="b-grey"></div>

            <div
              v-if="propertySelected && propertySelected.cancellationPolicy && user"
              class="announcement-content-small"
            >
              <div>
                <h1 class="font-md bold-medium ion-padding-bottom">
                  {{ t(`announcement.policy.title`) }}
                </h1>
                <p>{{ t(`announcement.policy.${propertySelected.cancellationPolicy}.1`) }}</p>
              </div>
            </div>

            <div
              v-if="propertySelected && propertySelected.cancellationPolicy && user"
              class="b-grey"
            ></div>

            <div class="announcement-content-small">
              <ion-row class="ion-justify-content-start price-subtitle nowrap">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/images/cocina.svg" alt="">
                </div>
                <div class="padding-list-item">
                  <h3 class="font-sm bold-medium grey no-margin-top">
                    {{ t('announcement.kitchenIncluded') }}
                  </h3>
                  <p class="list-item-text">
                    {{ t('announcement.yourOwnKitchen') }}
                  </p>
                </div>
              </ion-row>
              <!-- <ion-row class="ion-justify-content-start price-subtitle nowrap">
                <ion-icon :icon="homeOutline" size="large" color="grey"></ion-icon>
                <div class="padding-list-item">
                  <h3 class="font-sm bold-medium grey no-margin-top">
                    {{ t('announcement.sharedSpaces') }}
                  </h3>
                  <p class="list-item-text">{{ t('announcement.youWill') }}</p>
                </div>
              </ion-row>
              <ion-row class="ion-justify-content-start price-subtitle nowrap">
                <ion-icon :icon="locationOutline" size="large" color="grey"></ion-icon>
                <div class="padding-list-item">
                  <h3 class="font-sm bold-medium grey no-margin-top">
                    {{ t('announcement.sharedBathroom') }}
                  </h3>
                  <p class="list-item-text">{{ t('announcement.youWillShare') }}</p>
                </div>
              </ion-row> -->
            </div>
            <!-- <div
              v-if="propertySelected && propertySelected && user"
              class="announcement-content-small"
            >
              <div v-if="propertySelected?.Images">
                <h1 class="font-md bold-medium ion-padding-bottom">
                  {{ t('announcement.youWillStay') }}
                </h1>
                <img
                  class="principal-image border-default"
                  :src="
                    propertySelected?.Images[0]?.image
                      ? propertySelected?.Images[0]?.image
                      : 'https://st-web.lodgerin.com/images/image-not-found.webp'
                  "
                  alt=""
                />
              </div>
            </div> -->
          </div>

          <div class="b-grey"></div>

          <div v-if="mergedData && !internalGuideLoading" class="mt-lg">
            <p class="font-md bold-medium mb-xs">{{ t('post.guides') }}</p>
            <div class="d-flex post-content-list gap-xs mt-lg">
              <div v-for="post in getFilteredPosts" :key="post.id">
                <PostCard :post="post" />
              </div>
            </div>
          </div>
          <div v-else class="d-flex flex-column gap-xs mt-xs">
            <SkeletonLoaderCard />
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import {
    IonPage,
    IonContent,
    IonSkeletonText,
    IonSegmentButton,
    IonSegment,
    IonLabel,
    IonIcon,
    IonRow,
    IonButton,
    IonFabButton,
  } from '@ionic/vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import { Property } from '@/interfaces/elastic/elastic.interface';
  import { useI18n } from 'vue-i18n';
  import SkeletonLoaderCard from '@/components/loaders/SkeletonLoaderCard.vue';
  import { useSearch } from '@/composables/useSearch';
  import MediaViewer from '@/components/announcement/MediaViewer.vue';
  import MediaPreview from '@/components/announcement/MediaPreview.vue';
  import { chatboxOutline, locationOutline } from 'ionicons/icons';
  import MapView from '@/components/announcement/MapView.vue';
  import { storeToRefs } from 'pinia';
  import { useAuthStore } from '@/stores/auth-store';
  import LodginForInformationProperty from '@/components/announcement/LodginForInformationProperty.vue';
  import SpacesInformationProperty from '@/components/announcement/SpacesInformationProperty.vue';
  import RentalUnitWrapper from '@/components/announcement/RentalUnit/RentalUnitWrapper.vue';
  import SmallCardModal from '@/components/announcement/SmallCardModal.vue';
  import { useWebflowStore } from '@/stores/webflow-store';
  import { useWebflow } from '@/composables/useWebflow';
  import PostCard from '@/components/posts/PostCard.vue';
  import { useProfileStore } from '@/stores/profile-store';
  import { useShepherd } from 'vue-shepherd';
  import { amountMask } from '@/utils/validations/formats';

  const { languageSelected } = storeToRefs(useProfileStore());

  const { t } = useI18n();
  const isLoading = ref(true);

  const tour = useShepherd({
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'tour',
    },
  });

  const { getCurrentNameProperty, propertySelected, handleGetPropertyPublic } = useSearch();
  const { mergedData, todayPosts } = storeToRefs(useWebflowStore());
  const { internalGuideLoading, handleGetCollections, getFilteredCategoriesPosts, getCategory } =
    useWebflow();

  const route = useRoute();
  const tabSelected = ref('photos');
  const { user } = storeToRefs(useAuthStore());

  const onBackButton = () => {
    router.replace({ name: 'Explore' });
  };

  const getFilteredPosts = computed(() => {
    const posts = getFilteredCategoriesPosts(
      getCategory(),
      propertySelected?.value?.Location?.country ??
        (propertySelected?.value?.Location?.city as string),
    );
    return posts.length > 0 ? posts : todayPosts.value;
  });

  const images = computed(() => {
    return propertySelected?.value?.Images ?? [];
  });

  const transformedLocation = computed(() => {
    const latString =
      propertySelected && propertySelected?.value ? propertySelected?.value.Location?.lat : '';
    const lonString =
      propertySelected && propertySelected?.value ? propertySelected?.value.Location?.lon : '';

    const lat = latString ? parseFloat(latString) : 0;
    const lon = lonString ? parseFloat(lonString) : 0;

    // Optional: Handle NaN cases
    const validLat = isNaN(lat) ? 0 : lat;
    const validLon = isNaN(lon) ? 0 : lon;

    return {
      lat: validLat,
      lon: validLon,
    };
  });

  const initialConfig = async () => {
    try {
      isLoading.value = true;
      await handleGetPropertyPublic(route.params.propertyId as string);
      setMetaData();
      await handleGetCollections();
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  const endTour = () => {
    tour.complete();
  };

  const initTour = () => {
    tour.addStep({
      attachTo: {
        element: '.house',
        on: 'top',
      },
      text: t('shepperdTour.modalText'),
      classes: 'tour',
      scrollTo: { behavior: 'smooth', block: 'center' },
      useModalOverlay: true,
      buttons: [
        {
          text: t('shepperdTour.finishButton'),
          action: tour.complete,
        },
      ],
    });
    tour.start();
  };

  const getCurrentDescription = (propertyObj?: Property) => {
    if (propertyObj && propertyObj.Texts) {
      return propertyObj.Texts[
        `description_${languageSelected.value}` as keyof typeof propertyObj.Texts
      ];
    }
    return propertyObj?.description ?? '';
  };

  const setMetaData = () => {
    if (propertySelected.value) {
      document.title = getCurrentNameProperty(
        propertySelected.value,
        languageSelected.value,
      ) as string;

      const ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      ogTitle.content = getCurrentNameProperty(
        propertySelected.value,
        languageSelected.value,
      ) as string;
      document.getElementsByTagName('head')[0].appendChild(ogTitle);
    }
  };

  initialConfig();
</script>

<style lang="css" scoped>
  .shepherd-element {
    background: #252627 !important;
    color: white;
  }
  .shepherd-text {
    color: rgb(255, 255, 255) !important;
    font-size: 1rem;
    line-height: 1.3em;
    padding: 0.75em;
  }
  .shepherd-button {
    background: rgb(43, 82, 217) !important;
    color: rgb(255, 255, 255) !important;
  }
  ion-fab {
    margin-top: var(--ion-safe-area-top, 0);
  }
</style>
